<template>
  <router-view :key="$route.fullPath" />
</template>

<style>
  @import './assets/main.css';
</style>
